import { gql } from "graphql-tag";

import { documentLink } from "~/app/prismic/prismic-fragments";

export const quickLinks = gql`
  fragment quickLinks on Store_page_contentBodyQuick_links {
    type
    label
    primary {
      title
      links_field
      customer_support_title
      customer_support_detail
      link_name
      email_to
      link {
        ...documentLink
      }
      link_label
    }
  }
  ${documentLink}
`;
